import styled, { keyframes } from 'styled-components'

const glowCyan = keyframes`
  0%, 100% { text-shadow: 0 0 10px rgba(0,229,255,0.6), 0 0 30px rgba(0,229,255,0.3); }
  50%       { text-shadow: 0 0 22px rgba(0,229,255,0.9), 0 0 55px rgba(0,229,255,0.5); }
`

/* ── Wrapper ── */
export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(rgba(10, 10, 10, 0.8), rgba(10, 10, 10, 0.85)),
              url('https://res.cloudinary.com/dys33ogt0/image/upload/v1772432476/backgroung_edsraz.png');
  background-size: 110%;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-bottom: 80px;
  font-family: inherit;
`

/* ── Hero ── */
export const HeroSection = styled.div`
  padding: 40px 3% 30px;
`

export const PageTitle = styled.h2`
  color: #fff;
  font-size: 2.6rem;
  font-weight: 900;
  font-style: italic;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0 0 10px 0;
  animation: ${glowCyan} 3s ease-in-out infinite;
  max-width: 800px;

  @media (max-width: 600px) {
    font-size: 1.8rem;
  }
`

export const HeroSubtitle = styled.p`
  color: #fff;
  font-size: 0.89rem;
  margin: 0 0 22px 0;
  max-width: 560px;
  line-height: 1.5;
`

export const BottomBar = styled.div`
  width: 95%;
  margin: 0 auto 40px auto;
  background-color: #0056ff;
  padding: 10px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  border-radius: 50px;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 15px;
    text-align: center;
    border-radius: 25px;
    padding: 20px;
  }
`

export const BottomText = styled.h2`
  color: #fff;
  font-style: italic;
  font-weight: bold;
  margin: 0;
  font-size: 1.5rem;
`

export const BottomBtn = styled.button`
  background-color: #fff000;
  color: #02e5ff;
  border: none;
  padding: 12px 30px;
  font-weight: bold;
  border-radius: 50px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }
`

export const PinkBtn = styled.a`
  display: inline-block;
  background: linear-gradient(135deg, #ff0066, #ff3399);
  color: #fff;
  padding: 11px 28px;
  border-radius: 26px;
  font-weight: 800;
  font-size: 0.85rem;
  text-transform: uppercase;
  text-decoration: none;
  letter-spacing: 1.5px;
  cursor: pointer;
  box-shadow: 0 0 14px rgba(255,0,102,0.6);
  transition: transform 0.2s;
  &:hover { transform: scale(1.04); }
`

export const HeroNote = styled.p`
  color: #fff;
  font-size: 0.88rem;
  margin: 12px 0 0 0;
`

/* ── Two-column layout ── */
export const TwoColGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  padding: 0 3% 0;

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
  }
`

export const LeftCol = styled.div`
  padding: 30px 20px 30px 0;
  border-right: 1px solid #1a1a1a;

  @media (max-width: 850px) {
    border-right: none;
    border-bottom: 1px solid #1a1a1a;
    padding: 24px 0;
  }
`

export const RightCol = styled.div`
  padding: 30px 0 30px 28px;

  @media (max-width: 850px) {
    padding: 24px 0;
  }
`

export const ColTitle = styled.h2`
  color: #fff;
  font-style: italic;
  font-weight: 800;
  font-size: 1.1rem;
  margin: 0 0 18px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
`

/* ── Overview cards (cyan border, subtle cyan fill) ── */
export const OverviewCard = styled.div`
  border: none;
  border-radius: 12px;
  padding: 25px 20px;
  margin-bottom: 20px;
  background-color: #00e5ff;
  box-shadow: 0 0 20px rgba(0, 229, 255, 0.4);
  transition: box-shadow 0.3s;
  &:hover { box-shadow: 0 0 20px rgba(0,229,255,0.35); }
`

export const OverviewCardTitle = styled.h3`
  color: #02e5ff;
  font-size: 1.1rem;
  font-weight: 900;
  margin: 0 0 10px 0;
`

export const OverviewCardText = styled.p`
  color: #02e5ff;
  font-size: 0.85rem;
  font-weight: 500;
  margin: 0;
  line-height: 1.5;
`

/* ── Requirement / HowItWorks icon cards (pink border) ── */
export const IconCardsRow = styled.div`
  display: flex;
  gap: 14px;
  margin-bottom: 14px;

  @media (max-width: 500px) {
    flex-direction: column;
  }
`

export const IconCard = styled.div`
  flex: 1;
  border: 1.5px solid #fc0a7e;
  border-radius: 10px;
  padding: 18px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  background: transparent;
  box-shadow: 0 0 10px rgba(252,10,126,0.2);
  transition: box-shadow 0.3s, transform 0.3s;
  cursor: default;
  &:hover {
    box-shadow: 0 0 20px rgba(252,10,126,0.45);
    transform: translateY(-2px);
  }
  img {
    width: 50px;
    height: 50px;
    object-fit: contain;
    filter: drop-shadow(0 0 8px rgba(252,10,126,0.6));
  }
`

export const IconCardLabel = styled.span`
  color: #fff;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const IconCardSub = styled.span`
  color: #888;
  font-size: 0.72rem;
`

/* ── "Who This Is For" cyan icon cards ── */
export const WhoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
`

export const WhoCard = styled.div`
  border: 1.5px solid #00e5ff;
  border-radius: 10px;
  padding: 18px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  background: transparent;
  box-shadow: 0 0 10px rgba(0,229,255,0.15);
  transition: box-shadow 0.3s, transform 0.3s;
  cursor: default;
  &:hover {
    box-shadow: 0 0 20px rgba(0,229,255,0.35);
    transform: translateY(-2px);
  }
  img {
     width: 50px;
     height: 50px;
     object-fit: contain;
     filter: drop-shadow(0 0 8px rgba(0,229,255,0.6));
  }
`

export const WhoCardLabel = styled.span`
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
`

/* ── HOW IT WORKS left side yellow banner card ── */
export const YellowCard = styled.div`
  background-color: #fff000;
  border-radius: 12px;
  padding: 22px 20px;
`

export const YellowCardBrand = styled.h3`
  color: #02e5ff;
  font-weight: 900;
  font-size: 1.3rem;
  font-style: italic;
  margin: 0 0 8px 0;
`

export const YellowCardText = styled.p`
  color: #333;
  font-size: 0.82rem;
  margin: 0 0 16px 0;
  line-height: 1.45;
`

export const YellowCardBrand2 = styled.h3`
  color: #fc0a7e;
  font-weight: 900;
  font-size: 1.1rem;
  font-style: italic;
  margin: 0 0 8px 0;
  text-shadow: 0 0 8px rgba(252,10,126,0.5);
`

/* ── Full-width divider section ── */
export const FullSection = styled.div`
  padding: 20px 3% 20px;
  border-top: 1px solid #1a1a1a;
`

export const SectionTitle = styled.h2`
  color: #fff;
  font-style: italic;
  font-weight: 800;
  font-size: 1.1rem;
  margin: 0 0 16px 0;
  text-transform: uppercase;
  letter-spacing: 1px;
`

/* ── Ottawa serving section ── */
export const ServingSection = styled.div`
  padding: 20px 3% 24px;
  border-top: 1px solid #1a1a1a;
`

export const ServingTitle = styled.h2`
  color: #fff;
  font-style: italic;
  font-weight: 800;
  font-size: 1.2rem;
  margin: 0 0 10px 0;
`

export const ServingText = styled.p`
  color: #888;
  font-size: 0.82rem;
  margin: 0;
  line-height: 1.5;
  max-width: 560px;
`

/* ── FAQ ── */
export const FAQGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`

export const FAQCard = styled.div`
  border: 1.5px solid #fc0a7e;
  border-radius: 10px;
  padding: 16px;
  background: transparent;
  box-shadow: 0 0 10px rgba(252,10,126,0.18);
  transition: box-shadow 0.3s, transform 0.3s;
  &:hover {
    box-shadow: 0 0 20px rgba(252,10,126,0.35);
    transform: translateY(-2px);
  }
`

export const FAQCardTitle = styled.h3`
  color: #fc0a7e;
  font-size: 0.82rem;
  font-weight: 700;
  margin: 0 0 8px 0;
  text-shadow: 0 0 8px rgba(252,10,126,0.5);
`

export const FAQCardText = styled.p`
  color: #999;
  font-size: 0.78rem;
  margin: 0;
  line-height: 1.4;
`

/* ── Sticky bar ── */
export const StickyBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 62px;
  background-color: #0055ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 -4px 20px rgba(0,85,255,0.5);
  z-index: 100;
`

export const StickyText = styled.span`
  color: #fff;
  font-size: 0.9rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 1.5px;

  @media (max-width: 500px) {
    font-size: 0.7rem;
  }
`

export const StickyApplyBtn = styled.a`
  background-color: #fff000;
  color: #02e5ff;
  padding: 9px 22px;
  border-radius: 6px;
  font-weight: 800;
  font-size: 0.82rem;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  transition: transform 0.2s;
  &:hover { transform: scale(1.04); }
`
